<template>
  <transition name="toast">
    <div
      v-if="visible"
      class="toast-banner"
      role="alert"
      aria-live="polite"
    >
      <p v-typo class="toast-banner__message">{{ message }}</p>

      <div class="toast-banner__actions">
        <button
          v-if="showUndo"
          type="button"
          class="toast-banner__undo"
          aria-label="Отменить действие"
          @click="handleUndo"
        >
          Отменить
        </button>

        <button
          type="button"
          class="toast-banner__close"
          aria-label="Закрыть уведомление"
          @click="handleClose"
        >
          <PhX :size="14" :weight="'bold'" aria-hidden="true" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { PhX } from '@phosphor-icons/vue'

export default {
  name: 'ToastNotification',
  components: {
    PhX
  },
  props: {
    message: {
      type: String,
      required: true
    },
    showUndo: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  mounted() {
    this.visible = true

    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        this.hide()
      }, this.duration)
    }
  },
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    handleUndo() {
      this.$emit('undo')
      this.hide()
    },
    handleClose() {
      this.$emit('close')
      this.hide()
    },
    hide() {
      this.visible = false
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.$emit('hidden')
    }
  }
}
</script>

<style scoped>
.toast-banner {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  z-index: 100002;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: min(24rem, calc(100vw - 2rem));
  max-width: calc(100vw - 2rem);
  padding: 0.75rem 0.75rem 0.75rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  transform: translateX(-50%);
}

.toast-banner__message {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.35;
  color: #0f172a;
  text-wrap: pretty;
}

.toast-banner__actions {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex-shrink: 0;
}

.toast-banner__undo {
  padding: 0.375rem 0.5rem;
  border: 0;
  background: transparent;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--primary-main, #dc2626);
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease;
}

.toast-banner__undo:hover {
  color: var(--primary-dark, #b91c1c);
}

.toast-banner__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.toast-banner__close:hover {
  background: #e2e8f0;
  color: #334155;
}

.toast-enter-active {
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}

.toast-leave-active {
  transition: opacity 0.2s ease-in, transform 0.2s ease-in;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(1rem);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-0.5rem);
}
</style>
